import script from "./AlliedSearchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlliedSearchBar.vue?vue&type=script&setup=true&lang=ts"

import "./AlliedSearchBar.vue?vue&type=style&index=0&id=490e4320&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-490e4320"]])

export default __exports__